import { useIsListView } from "hooks/useIsListView";
import { PrimitiveAtom } from "jotai";
import {
  IBenefitCategory,
  IBenefitImplementation,
  IBenefitPackage,
} from "library/types";
import { OrderSubmitContent } from "./OrderSubmitContent";

type Props = {
  itemList: IBenefitCategory[] | IBenefitImplementation[] | IBenefitPackage[];
  disabled: boolean;
  settingKey: string;
  itemIdProperty: string;
  orderedAtom: PrimitiveAtom<any[]>;
  searchFilterValue?: string;
};

export function BenefitCardOrderSubmit({
  itemList,
  disabled,
  orderedAtom,
  itemIdProperty,
  settingKey,
  searchFilterValue,
}: Props) {
  const isListView = useIsListView();

  if (isListView) {
    return null;
  }

  return (
    <OrderSubmitContent
      searchFilterValue={searchFilterValue}
      itemList={itemList}
      disabled={disabled}
      orderedAtom={orderedAtom}
      itemIdProperty={itemIdProperty}
      settingKey={settingKey}
    />
  );
}
